import { render } from "./PaymentSepay.vue?vue&type=template&id=036b7d65&scoped=true"
import script from "./PaymentSepay.vue?vue&type=script&lang=js"
export * from "./PaymentSepay.vue?vue&type=script&lang=js"

import "./PaymentSepay.vue?vue&type=style&index=0&id=036b7d65&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036b7d65"]])

export default __exports__